import { ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GoogleFontIcon, Input } from '@asset-metrix/portal-ui';
import { useShallow } from 'zustand/react/shallow';

import { useStore } from '../../store';
import { SearchFilterData } from '../../store/states/filterTypes';

export type SearchFilterProps = {
  entityId: string;
  filterData?: SearchFilterData;
  filterKey: string;
  isFetching: boolean;
  label?: ReactNode | ReactNode[];
};

export function SearchFilter({
  entityId,
  filterData,
  filterKey,
  isFetching,
  label,
}: SearchFilterProps) {
  const [value, setValue] = useState(filterData?.selection ?? '');
  useEffect(() => {
    setValue(filterData?.selection ?? '');
  }, [filterData?.selection]);

  const [setFilterSelection, resetFilterSelection] = useStore(
    useShallow((state) => [
      state.setFilterSelection,
      state.resetFilterSelection,
    ])
  );

  const { t } = useTranslation();
  return (
    <Input
      data-testid="search-filter"
      leftSection={<GoogleFontIcon name="search" />}
      clearable={true}
      label={label}
      loading={isFetching}
      placeholder={t('app.search.placeholder')}
      value={value}
      onCommit={(value) => {
        if (value !== '') {
          setFilterSelection(entityId, filterKey, 'text', 'search', value);
        } else {
          resetFilterSelection(entityId, filterKey);
        }
      }}
      onChange={setValue}
    />
  );
}
